import { defineStore } from 'pinia'
const storage = window.sessionStorage
const SUBSCRIPTIONS_KEY = 'UadSubscriptions'
const TICKET_ID_KEY = 'UadTicketId'

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    subscriptions: JSON.parse(storage.getItem(SUBSCRIPTIONS_KEY) || null),
    ticket_id: storage.getItem(TICKET_ID_KEY),
    subscriptionsLoading: false
  }),
  actions: {
    setSubscriptions(subs) {
      this.subscriptions = subs
      if (subs) {
        storage.setItem(SUBSCRIPTIONS_KEY, JSON.stringify(subs))
      } else {
        storage.removeItem(SUBSCRIPTIONS_KEY)
      }
    },
    setSubscriptionsLoading(loading) {
      this.subscriptionsLoading = loading
    },
    setTicketId(ticket_id) {
      this.ticket_id = ticket_id
      if (ticket_id) {
        storage.setItem(TICKET_ID_KEY, ticket_id)
      } else {
        storage.removeItem(TICKET_ID_KEY)
      }
    },
    logout() {
      this.setSubscriptions()
      this.setTicketId()
    }
  },
  getters: {
    getSubscriptions: ({subscriptions}) => subscriptions,
    getSubscriptionsLoading: ({subscriptionsLoading}) => subscriptionsLoading,
    getTicketId: ({ticket_id}) => ticket_id
  }
})